<template>
    <div class="about">
        <div v-if="catalogue">
            <h1>{{ catalogue.name }}</h1>
            {{ catalogue.description }}
            <h3>Groups</h3>
            <b-card v-if="!loading" v-for="group in catalogue.questionnaire_groups" :title="group.name + ' ' + group.description">
                <b-card v-if="group.child_questionnaire_groups" v-for="child in group.child_questionnaire_groups" :title="child.name + ' ' + child.description">
                    <b-table hover :items="child.questionnaires" :fields="fields">
                        <template slot="optional" slot-scope="data">
                        <b-checkbox v-model="!! + data.item.optional" disabled><span v-if="data.item.optional">Yes</span><span v-else>No</span></b-checkbox>
                        </template>
                        <template slot="rate_each_step" slot-scope="data">
                            <b-checkbox v-model="!! + data.item.rate_each_step" disabled><span v-if="data.item.rate_each_step">Yes</span><span v-else>No</span></b-checkbox>
                        </template>
                    </b-table>
                </b-card>
                <b-table hover :items=group.questionnaires :fields="fields">
                    <template slot="optional" slot-scope="data">
                        <b-checkbox v-model="!! + data.item.optional" disabled><span v-if="data.item.optional">Yes</span><span v-else>No</span></b-checkbox>
                    </template>
                    <template slot="rate_each_step" slot-scope="data">
                        <b-checkbox v-model="!! + data.item.rate_each_step" disabled><span v-if="data.item.rate_each_step">Yes</span><span v-else>No</span></b-checkbox>
                    </template>
                </b-table>
            </b-card>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
      form: {
        name: '',
        description: ''
      },
      catalogue: null,
      show: true,
      fields : [
          {
              key: 'name',
              label: 'No'
          },
          {
              key: 'description',
              label: 'Description'
          },
          {
              key: 'optional',
              label: ''
          },
          {
            ley: 'double_rating',
            label: 'Process & Product'
          },
          {
              key: 'rate_each_step',
              label: 'Repeat'
          }
      ]
    }
  },
  methods: {
    on_submit (evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
      this.$http.post('v1/questionnairecatalogues', this.form).then(response => {
          console.log(response)
          if (response.status == 200) {
              this.$router.push('/catalogue/' + response.data.response._id);
          }
      })
    },
    on_reset (evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.order_no = '';
      this.form.name = '';
      this.form.date = null;
      this.form.reason = '';
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => { this.show = true });
    }
  },
  created () {
      this.fetchData()
  },
  watch: {
      '$route': 'fetchData'
  },
  methods: {
      fetchData() {
          this.error = this.post = null;
          this.loading = true;
          this.$http.get('v1/questionnairecatalogues/' + this.$route.params.questionnaire_catalogue_id).then(response => {
              this.catalogue = response.data.response;
              this.loading = false;
          });
      }
  }
}
</script>
